var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"inline-block",attrs:{"icon":"","color":"primary","loading":_vm.cargando,"disabled":_vm.disabled},on:{"click":function($event){return _vm.generarPdf()}}},[_c('v-img',{attrs:{"src":require('../../../assets/iconos/pdf.png'),"contain":"","height":"30"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }